<div class="map-container">
  <div class="map-frame">
    <div #mapContainer class="map"></div>
  </div>
</div>